import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledFixedBottomButton = styled.button`
    position: fixed;
    bottom: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    padding: 4px;
    font-size: var(--size-12);
    font-style: normal;
    font-weight: bold;
    line-height: 20px;
    color: var(--color-primary);
    cursor: pointer;
    background: var(--color-selected);
    border: none;
    border-radius: var(--radius-top-10);
    box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.05);
    @media ${breakpoints.xs} {
        padding: 4px;
        font-size: var(--size-12);
        line-height: 20px;
    }
`;
